import {createVuetify} from "vuetify";
import { aliases, mdi } from 'vuetify/iconsets/mdi-svg';
import { cs, en } from 'vuetify/locale'
export const defaultAccent = '#FB8C00';

export default function(color, clientWidth) {
    return createVuetify({
        ssr: import.meta.env.SSR ? (clientWidth ? {clientWidth} : true) : false,
        theme: {
            options: {
                customProperties: true
            },
            themes: {
                light: {
                    colors: {
                        'cis-accent-color': color || defaultAccent
                    }
                }
            }
        },
        icons: {
            defaultSet: 'mdi',
            aliases,
            sets: {
                mdi,
            },
        },
        locale: {
            locale: 'cs',
            fallback: 'en',
            messages: { cs, en },
        },
        defaults: {
            VImg: {crossOrigin: true}
        },
    });
}
